import { FunctionComponent } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { productMap, LocaleTypes } from '@/config/whole-home-backup-power-solution';
import { createEFPic } from '@/utils/useEFPic';
import EfImg from 'elem/ui/ef-img';

const { EFPic } = createEFPic('/img/landingPage/product/');
const Ecosystem: FunctionComponent = () => {
    const { useLang, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const productList: any = productMap[locale as LocaleTypes] || productMap.ca;

    return (
        <section className={`${css.Ecosystem} Ecosystem-style`}>
            <div className="title">{t('secN_title')}</div>
            <div className="flex-warp-list">
                {productList.map((item: any, index: number) => (
                    <div className="item-wrap content-wrap" key={`item-wrap-${index}`}>
                        <div className="name">{t(item.name)}</div>
                        {String(item.img).startsWith('https://') ? (
                            <EfImg className="product-img" pc={item.img} />
                        ) : (
                            <EFPic name={item.img} className="product-img" />
                        )}
                        {item.link && (
                            <Link
                                className="buy-btn"
                                href={item?.link}
                                target="blank"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: t(item?.name),
                                    position: `Solution Page_${t('secN_title')}`,
                                }}
                            >
                                {t('learn_more')}
                            </Link>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Ecosystem;
